import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _typeof from "@babel/runtime/helpers/typeof";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { RouterService } from '@tokamakjs/common';
import { HookService } from '../../decorators/hook-service.decorator';
import { useLocation, useNavigate, useParams } from '../../routing';

var RouterHookService = /*#__PURE__*/function (_RouterService) {
  _inherits(RouterHookService, _RouterService);

  var _super = _createSuper(RouterHookService);

  function RouterHookService() {
    var _this;

    _classCallCheck(this, RouterHookService);

    _this = _super.apply(this, arguments);
    _this._params = useParams();
    _this._location = useLocation();
    _this._navigate = useNavigate();
    return _this;
  }

  _createClass(RouterHookService, [{
    key: "location",
    get: function get() {
      return this._location;
    }
  }, {
    key: "rawQuery",
    get: function get() {
      return this._location.search;
    }
  }, {
    key: "getParams",
    value: function getParams() {
      return this._params;
    }
  }, {
    key: "push",
    value: function push(to, state) {
      this._navigate(to, {
        state: state
      });
    }
  }, {
    key: "replace",
    value: function replace(to, state) {
      this._navigate(to, {
        state: state,
        replace: true
      });
    }
  }]);

  return RouterHookService;
}(RouterService);

RouterHookService = __decorate([HookService()], RouterHookService);
export { RouterHookService };